import { openModal } from "action/modal/openModal";
import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { ITags } from "api/interfaces/get-page-details/product-page.type";
import { IPageContent } from "api/interfaces/static-content.type";
import PAImage from "component/design-system/images/PAImage";
import ProductTags from "component/product/product-tags/ProductTags";
import useScreenSize from "hoc/useScreenSize";
import MagnifyingGlassPlusIcon from "icons/MagnifyingGlassPlusIcon";
import { RootState } from "interfaces/generics.type";
import { getLinePageThumbImagePath } from "modules/product/line-page/utils";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { getThumbImage } from "util/helper/getThumbImage";
import { PAGE_TYPES } from "util/product/product-constants";
import MobileImageSlider from "./MobileImageSlider";
import { StyledSliderContiner } from "./StyleComponent";
import styles from "./styles.module.scss";

interface IProps {
  product: ICompactProduct;
  staticContent: IPageContent;
}

function ProductImageSection(props: IProps) {
  const {
    productImages, productImagesV2 = [], manufacturer, manufactureImageUrl, imageTitle, outOfStock,
    getThumbImagePath, getProductImagePath, // description, rating, thumbnail, price, maximumPrice, minimumPrice,
    product, staticContent, zoomImagePosition, showDots, imageContainerHeight, fromSideMenu,
    largeImage, isRegularDesktop = false, //  showPartNumber,
  } = props;
  const {
    marketingImages = [], productLineVideos = [], videos = [], manufacturerVideos = [],
  } = staticContent;
  const isWebpImage = productImagesV2.length > 0;
  const updatedVideos = (productLineVideos && productLineVideos.length > 0 ? productLineVideos : videos).map((vid: any) => ({ ...vid, type: "video" }));

  // https://integ.partsavatar.ca/monroe-expert-series-rear-max-air-ma837 we have marketing images as a new array
  const { currentPageType } = useSelector((store: RootState) => store.utils);
  const [selectedImage, setSelectedImage] = useState(0);
  // const [zoomOpen, setZoomOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isMobile] = useScreenSize();

  const { tags: productTags = [] }: { tags: ITags[] } = staticContent?.links || {};
  // const averageRating = product?.averageRating || 0;
  // const totalReviewsCount = product?.totalReviewsCount || 0;
  // const partNumber = product?.partNumber || "";

  const dispatch = useDispatch();

  // function closeSection() {
  //   setZoomOpen(false);
  // }

  function handleMouseEnter() {
    if (!isHovered) {
      setIsHovered(true);
    }
  }

  function handleZoomClick() {
    if (!product && currentPageType !== PAGE_TYPES.PRODUCT_LINE_PAGE) {
      return;
    }
    dispatch(openModal("thumbnailVideo", {
      productImagesV2,
      productImages,
      getThumbImagePath: currentPageType === PAGE_TYPES.PRODUCT_LINE_PAGE ? getLinePageThumbImagePath : getThumbImage,
      marketingImages,
      imageTitle,
      product,
      productLineVideos: [...updatedVideos, ...manufacturerVideos],
      isImageClick: true,
      defaultSelectedImage: selectedImage,
      isMobile,
    }));
  }

  const containerHeight = {
    height: imageContainerHeight ? `${imageContainerHeight}px` : null,
  };

  return (
    <div className={styles.image_section} onMouseEnter={handleMouseEnter} onTouchStart={handleMouseEnter}>

      <div className={`d-flex align-items-center justify-content-between flex-wrap ${styles.image_section_top}`}>
        <div className="hidden-sm hidden-xs">
          <PAImage
            src={getRelativeImagePath(manufactureImageUrl)}
            width={155}
            height={42}
            alt={`Upgrade your ride with premium ${manufacturer} auto parts`}
            title={`Upgrade your ride with premium ${manufacturer} auto parts`}
            className={styles.image_section_manufacturer}
          />
        </div>
        {/* <div className={styles.show_on_mobile}>
          <ReviewRating totalReviewsCount={totalReviewsCount} averageRating={averageRating} />
        </div> */}

        <ProductTags
          productTags={productTags.slice(0, 1)}
          className={styles.product_tags}
        />
      </div>

      <div className={`${styles.mobile_search} ${styles.show_on_mobile}`} onClick={handleZoomClick}>
        <MagnifyingGlassPlusIcon />
      </div>

      <StyledSliderContiner style={containerHeight} fromSideMenu={fromSideMenu} isWebpImage={isWebpImage}>
        <div className={styles.imageSlider}>

          <MobileImageSlider
            {...{
              productImages,
              productImagesV2,
              imageTitle,
              selectedImage,
              setSelectedImage,
              marketingImages,
              getThumbImagePath,
              getProductImagePath,
              outOfStock,
              isHovered,
              product,
              productLineVideos: [...productLineVideos, ...manufacturerVideos],
              videos,
              isRegularDesktop,
            }}
            isFluidWidth
            zoomImagePosition={zoomImagePosition}
            showDots={showDots}
            fromSideMenu={fromSideMenu}
            largeImage={largeImage}
          />
        </div>
      </StyledSliderContiner>
    </div>
  );
}

export default ProductImageSection;
